import { getInitState } from 'app/utils/async-middleware';
import { actionTypes } from 'app/common/actions/threat-surfaces';

const initState = getInitState();

export default (state = { ...initState }, action: any) => {
  switch (action.type) {
    case actionTypes.fetchThreatSurfaces: {
      const { type, ...restAction } = action;

      return {
        ...state,
        ...restAction,
      };
    }

    default:
      return state;
  }
};
